<apcam-shared-dialog-shell [config]="dialogShellConfig">
    <div class="overflow-hidden h-auto">
        <div>
            {{ 'shared.sentEmailDetail.sentAtUtc' | translate }}:
            <strong>{{
                emailDetail.sentAtUtc | translateDate: 'medium'
            }}</strong>
        </div>
        <div>
            {{ 'shared.sentEmailDetail.senderEmail' | translate }}:

            <strong>{{ emailDetail.senderEmail }}</strong>
        </div>
        <div>
            {{ 'shared.sentEmailDetail.recipientEmail' | translate }}:
            <strong>{{ emailDetail.recipientEmail }}</strong>
        </div>
        <div>
            {{ 'shared.sentEmailDetail.subject' | translate }}:
            <strong>{{ emailDetail.subject }}</strong>
        </div>
        <div class="mb-4 break-words">
            {{ 'shared.sentEmailDetail.message' | translate }}:<br /><span
                [innerHTML]="emailDetail.body"></span>
        </div>
    </div>
</apcam-shared-dialog-shell>
